import React from 'react';
export const MyJewerlydesign = ({currentpage,setcurrentpage}) => {
  if (currentpage==="/My_Jewerly_design"){
	  return (
		<div>
			<h1>My Jewerly Design</h1>
		</div>
	  );
  }
};